import { useState } from "react";
import { PaperclipIcon } from "lucide-react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/Base/Popover";
import { Badge } from "@/components/Base/Badge";
import { Card } from "@/types/v2";
import { AttachmentsMain } from "@/components/Common/Attachments/AttachmentsMain";
import { cardAttachmentsPath, cardPath } from "@/repositories/attachment";
import { cn } from "@/lib/utils";

export interface AttachmentsPopoverProps {
  cardData: Card;
  disabled?: boolean;
  shopId: string;
  iconSize?: number;
}

export const AttachmentsPopover = ({
  cardData,
  shopId,
  disabled,
  iconSize = 14,
}: AttachmentsPopoverProps) => {
  const [open, setOpen] = useState(false);
  const count = cardData.attachmentCount ?? 0;

  if (!shopId) return null;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger
        aria-label={
          count > 0
            ? `Attachments: ${count > 99 ? "99+" : count}`
            : "Attachments"
        }
        disabled={disabled && count === 0}
        className={cn(
          "z-5 flex cursor-pointer items-center gap-0.5 rounded-full hover:bg-white/50",
          disabled && count === 0 && "cursor-default opacity-50"
        )}
        onMouseDown={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
      >
        {count > 0 ? (
          <Badge
            className="flex min-w-[1rem] items-center justify-center rounded px-0.5"
            variant={"default"}
            type={"small"}
          >
            {count > 99 ? "99+" : count}
          </Badge>
        ) : (
          <PaperclipIcon size={iconSize} />
        )}
      </PopoverTrigger>
      <PopoverContent
        onMouseDown={(e) => e.stopPropagation()}
        className="flex max-h-[500px] w-96 flex-col gap-2 overflow-y-auto bg-card p-2"
      >
        <AttachmentsMain
          shopId={shopId}
          entityPath={cardPath(shopId, cardData.id)}
          attachmentsPath={cardAttachmentsPath(shopId, cardData.id)}
          canModify={!disabled}
        />
      </PopoverContent>
    </Popover>
  );
};
